// extracted by mini-css-extract-plugin
export default {"button":"button--VgQfE","has_animation":"has_animation--I5T3J","adjustment":"adjustment--FYf9u","fadeSlideUp":"fadeSlideUp--oNwSE"};